"use client";

import React from "react";
import { ShieldCheck, Award, Sparkles } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Qualified Expert",
  icon: ShieldCheck
}, {
  title: "Clinical Excellence",
  icon: Award
}, {
  title: "Personal Approach",
  icon: Sparkles
}];
export default function OurClinicalPhilosophy() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="76651" id="the-face-behind-the-brand" className="bg-background relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-[10%] -top-[20%] h-[70%] w-[50%] rounded-full bg-accent/20 blur-[120px]" />
        <div className="absolute -bottom-[20%] -right-[10%] h-[50%] w-[40%] rounded-full bg-primary/10 blur-[100px]" />
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-12 lg:gap-24">
          
          {}
          <div ref={imageRef} className={`lg:col-span-7 transition-all duration-1000 ease-out ${isImageVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
            <div className="relative overflow-hidden rounded-[2.5rem] border border-border/20 bg-card/40 p-2 backdrop-blur-sm shadow-xl shadow-foreground/5">
              <AspectRatio ratio={4 / 3}>
                <img src="https://content-man.10web.cloud/wp-content/uploads/2026/03/622213180_1744921100164171_8675572765727855444_n.jpg" alt="Natalia, founder of Natalia's Beauty" className="h-full w-full rounded-[2rem] object-cover" />
                {}
                <div className="absolute inset-0 rounded-[2rem] ring-1 ring-inset ring-white/20" />
              </AspectRatio>
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col lg:col-span-5 transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
            <h2 className="mb-8 font-serif text-4xl leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl">
              The Heart Behind <br />
              <span className="text-accent italic">Natalia's Beauty.</span>
            </h2>
            
            <p className="mb-12 font-sans text-lg leading-loose text-muted-foreground">
              Founded by Natalia, our Brooke sanctuary is the culmination of years of passion for clinical excellence. With a background in advanced aesthetics, Natalia treats every client as a unique canvas, blending technical precision with a warm, personal touch. Her mission is to provide transformative results in an environment of complete serenity.
            </p>

            {}
            <div className="flex flex-wrap items-center gap-x-8 gap-y-6 border-t border-border/30 pt-8">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3">
                  <div className="flex size-10 items-center justify-center rounded-full bg-accent/20 text-accent-foreground">
                    <feature.icon className="size-5" strokeWidth={1} />
                  </div>
                  <span className="font-sans text-xs font-semibold uppercase tracking-widest text-foreground/80">
                    {feature.title}
                  </span>
                </div>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}